module.exports = __webpack_public_path__ + "img/67.1b038979.jpg";